/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportPlayerAttributeUpsertParams = {
    key: ReportPlayerAttributeUpsertParams.key;
    value: boolean;
};
export namespace ReportPlayerAttributeUpsertParams {
    export enum key {
        TEAMMATE = 'TEAMMATE',
        COMPETES = 'COMPETES',
        WINNING_PLAYS = 'WINNING_PLAYS',
        UPSIDE = 'UPSIDE',
        PHYSICALLY_TOUGH = 'PHYSICALLY_TOUGH',
        PLAYS_HARD = 'PLAYS_HARD',
        GETS_EXTRA_POSSESSIONS = 'GETS_EXTRA_POSSESSIONS',
        POSITIVE_ENERGY = 'POSITIVE_ENERGY',
        COMMUNICATES = 'COMMUNICATES',
        PLAYS_WITH_PASSION_AND_EMOTIONS = 'PLAYS_WITH_PASSION_AND_EMOTIONS',
        TEAM_FIRST_MINDSET = 'TEAM_FIRST_MINDSET',
        IMPROVEMENT_DRIVEN = 'IMPROVEMENT_DRIVEN',
        IMPACTS_WINNING = 'IMPACTS_WINNING',
    }
}

